import { Table } from '@chakra-ui/react'
import type { FC } from 'react'

interface Props {
  data: string[]
}

const PreviewTableBody: FC<Props> = ({ data }) => (
  <Table.Body>
    {data?.map((record) => (
      <Table.Row>
        {Array.isArray(record) && record.map((cell) => <Table.Cell>{cell.toString()}</Table.Cell>)}
        {!Array.isArray(record) && Object.values(record).map((cell) => <Table.Cell>{cell.toString()}</Table.Cell>)}
      </Table.Row>
    ))}
  </Table.Body>
)

export default PreviewTableBody
